import { render, staticRenderFns } from "./FunnelChart.vue?vue&type=template&id=4bf94cd7&scoped=true"
import script from "./FunnelChart.vue?vue&type=script&lang=js"
export * from "./FunnelChart.vue?vue&type=script&lang=js"
import style0 from "./FunnelChart.vue?vue&type=style&index=0&id=4bf94cd7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf94cd7",
  null
  
)

export default component.exports